module.exports = __webpack_public_path__ + "static/media/BD-Snake_mustache.bc818526.png";